<template>
  <div class="cta-container">
    <h2>Bereit, durchzustarten?</h2>
    <p>
      Hol dir jetzt dein individuelles, rechtssicheres Dokument und starte
      durch!
    </p>
    <button @click="handleClick">Jetzt starten</button>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick() {
      window.location = "/login";
    },
  },
};
</script>

<style scoped>
.cta-container {
  color: #333;
  text-align: center;
  padding: 40px 20px;
  border-radius: 8px;
  margin: 40px 0;
}

.cta-container h2 {
  font-size: 32px;
  margin-bottom: 10px;
}

.cta-container p {
  font-size: 18px;
  margin-bottom: 20px;
}

.cta-container button {
  background: #333;
  color: #f0f0f0;
  border: none;
  padding: 15px 30px;
  font-size: 16px;
  border-radius: 3px;
  cursor: pointer;
}

.cta-container button:hover {
  background: #444;
  color: #f0f0f0;
}
</style>
